import { registerLazyNotificationRenderer } from "@/entities/notification"

registerLazyNotificationRenderer(
	"character-message",
	() => import("../ui/character-message-popup"),
)
